// src/pages/Acoes/components/ResultadoAmostra.jsx
import React from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import { formatarContagem, formatarLog10 } from '../../../utils/coleta';
import { rotuloDoAlvo } from '../../../utils/predicao';

const dois = (n) => String(n).padStart(2, '0');
const diaMes = (iso) => {
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? '' : `${dois(d.getDate())}/${dois(d.getMonth() + 1)}`;
};

/**
 * Resultado de uma amostra no plano de ação ("antes" / "depois"): a contagem da página
 * (leite) ou a presença de cada alvo (água, qualitativa). Abaixo, o código da amostra e
 * a data, que levam ao detalhe.
 */
export default function ResultadoAmostra({ resultado, unidade, onAbrir }) {
    if (!resultado) return null;
    const temContagem = Number.isFinite(resultado.log10Contagem);
    const alvos = resultado.alvos || [];

    return (
        <Box>
            {temContagem ? (
                <>
                    <Typography fontWeight={800} sx={{ fontSize: '1.35rem', lineHeight: 1.2 }}>
                        {formatarContagem(resultado.log10Contagem)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" display="block">
                        {unidade} · {formatarLog10(resultado.log10Contagem)}
                    </Typography>
                </>
            ) : resultado.ausente ? (
                <Typography fontWeight={800} color="success.main" sx={{ fontSize: '1.15rem' }}>Ausente</Typography>
            ) : alvos.length > 0 ? (
                <Stack spacing={1}>
                    {alvos.map((a) => (
                        <Box key={a.alvo}>
                            <Typography variant="caption" color="text.secondary" display="block">{rotuloDoAlvo(a.alvo)}</Typography>
                            <Typography fontWeight={800} sx={{ fontSize: '1.1rem', lineHeight: 1.2 }}>
                                {a.presenca === true ? 'Detectado' : a.presenca === false ? 'Não detectado' : '—'}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">Resultado qualitativo</Typography>
                        </Box>
                    ))}
                </Stack>
            ) : (
                <Typography variant="body2" color="text.secondary">
                    {resultado.processado ? 'Sem contagem' : 'Ainda não processada'}
                </Typography>
            )}
            <Link
                component="button"
                type="button"
                variant="caption"
                underline="hover"
                onClick={() => onAbrir?.(resultado)}
                sx={{ mt: 1, display: 'inline-block' }}
            >
                {resultado.identificacao} · {diaMes(resultado.dataHora)}
            </Link>
        </Box>
    );
}
